import ShipmentService from '../../api/shipments.service';
// import Cookies from 'js-cookie';

const state = {};

const getters = {};

const actions = {
	async getSalesFulfillment({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await ShipmentService.getSalesFulfillmentAsync(authToken);
		return response;
	},

	async getBackOrderFulfillment({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await ShipmentService.getBackOrderFulfillmentAsync(
			authToken
		);
		return response;
	},

	async getAllShipments({ dispatch }) {
		let getSalesFulfillment = dispatch('getSalesFulfillment');
		let getBackOrderFulfillment = dispatch('getBackOrderFulfillment');
		let response = await Promise.all([
			getSalesFulfillment,
			getBackOrderFulfillment,
		]);
		return response;
    },
    
    async updateShipments({ rootState }, request) {
		const { authToken } = rootState.auth;
		const response = await ShipmentService.updateShipmentsAsync(
            authToken,
            request
		);
		return response;
	}
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
